import { render, staticRenderFns } from "./EditAdvertisement.vue?vue&type=template&id=58704442&scoped=true&"
import script from "./EditAdvertisement.vue?vue&type=script&lang=js&"
export * from "./EditAdvertisement.vue?vue&type=script&lang=js&"
import style0 from "./EditAdvertisement.vue?vue&type=style&index=0&id=58704442&scoped=true&lang=css&"
import style1 from "./EditAdvertisement.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58704442",
  null
  
)

export default component.exports